import { render, staticRenderFns } from "./Cumulative.vue?vue&type=template&id=04a379b4"
import script from "./Cumulative.vue?vue&type=script&lang=js"
export * from "./Cumulative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports